/**
 *
 * IMPORTANT:
 * This file is used both is Vue2 and Vue3 files
 * DOnt use the Vue synax and store concept in the file
 * FOr more clarifications contact Leela
 *
 */
export const SET_KELLY_BLUE_BOOK_VIN_DATA = '[kelly blue book] set data with vin';
export const SET_KELLY_BLUE_BOOK_WITH_VIN_MORE_VEHICLES_WITH_VIN =
  '[kelly blue book] set more vehicles with vin';

export const SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_YEAR =
  '[kelly blue book] selected year without vin';
export const SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_MAKE =
  '[kelly blue book] selected make without vin';
export const SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_MODEL =
  '[kelly blue book] selected model without vin';
export const SET_KELLY_BLUE_BOOK_WITHOUT_VIN_MODEL_YEAR_ID =
  '[kelly blue book] set model year id without vin';
export const SET_KELLY_BLUE_BOOK_WITHOUT_VIN_SELECTED_VEHICLE_DATA =
  '[kelly blue book] set vehicle data without vin';
export const SET_KELLY_BLUE_BOOK_SUCCESS = '[kelly blue book] set success';

export const SET_KELLY_BLUE_BOOK_WITH_VIN_DETAILS = '[kelly blue book] set data with vin details';
export const SET_KELLY_BLUE_BOOK_CURRENT_STEP_NAME = '[kelly blue book] set current step name';
export const SHOW_KBB_TRADE_BUTTONS = '[kelly blue book] show next and back buttons';

export const SET_KELLY_SELECTED_VEHICLE_DETAILS = '[kelly blue book] selected vehicle details';
export const GUARANTEED_TRADE_IN_RESPONSE = '[kelly blue book] guarenteed trade in response';
export const GUARANTEED_TRADE_IN_VIN = '[kelly blue book] guarenteed trade in vin';
